import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CMSService } from 'src/app/services/CMS/cms.service';

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.css']
})
export class WebsiteComponent implements OnInit {

  SelectedFileForHeaderLogoUpload: any;
  JosaUrlList: any;
  SelectedFileForFooterLogoUpload: any;
  WebsiteList=[];
  Submitted: boolean = false;

  constructor(private cmsservice: CMSService, private LookupService: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  GetWebsite() {
    this.WebsiteList = [];
    this.spinnerService.show();
    this.cmsservice.GetWebsite(JSON.stringify(this.WebsiteModel)).subscribe((data: any) => {
      this.WebsiteList = data.WebsiteData;
      this.spinnerService.hide();

    });
  };


  WebsiteModel = {
    WebsiteID: 0,
    JOSAURLID: 0,
    LogoPath: '',
    FooterLogoPath: '',
    WelcomeMessage: '',
    Copyright: '',
    PoweredBy: '',
    PoweredByUrl: '',
    Partner: '',
    PartnerUrl: '',

  }

  ClearWebsite() {
    this.Submitted = false;
    this.WebsiteModel.WebsiteID = 0;
    this.WebsiteModel.LogoPath = '';
    this.WebsiteModel.FooterLogoPath = '';
    this.WebsiteModel.WelcomeMessage = '';
    this.WebsiteModel.Copyright = '';
    this.WebsiteModel.PoweredBy = '';
    this.WebsiteModel.PoweredByUrl = '';
    this.WebsiteModel.Partner = '';
    this.WebsiteModel.PartnerUrl = '';
  }


  EditWebsite(obj) {
    this.WebsiteModel.WebsiteID = obj.WebsiteID;
    this.WebsiteModel.JOSAURLID = obj.JOSAURLID;
    this.WebsiteModel.LogoPath = obj.LogoPath;
    this.WebsiteModel.FooterLogoPath = obj.FooterLogoPath;
    this.WebsiteModel.WelcomeMessage = obj.WelcomeMessage;
    this.WebsiteModel.Copyright = obj.Copyright;
    this.WebsiteModel.PoweredBy = obj.PoweredBy;
    this.WebsiteModel.PoweredByUrl = obj.PoweredByUrl;
    this.WebsiteModel.Partner = obj.Partner;
    this.WebsiteModel.PartnerUrl = obj.PartnerUrl;

  }

  selectFileforHeaderLogoUpload(file) {
    this.SelectedFileForHeaderLogoUpload = file[0];
  };

  selectFileforFooterLogoUpload(file) {
    this.SelectedFileForFooterLogoUpload = file[0];
  };


  Validation() {
    return this.WebsiteModel.JOSAURLID == 0;
  }

  SaveWebsite(valid) {
    this.Submitted = true;
    if (valid && !this.Validation()) {
      this.spinnerService.show();
      this.cmsservice.SaveWebsite(JSON.stringify(this.WebsiteModel), this.SelectedFileForHeaderLogoUpload, this.SelectedFileForFooterLogoUpload).subscribe((data: any) => {
        this.spinnerService.hide();
        if (data.webResponse.Status && this.WebsiteModel.WebsiteID == 0) {
          this.ClearWebsite();
        }

        if (data.webResponse.Status) {
          this.globalHelper.CheckActionStatus(data);
          this.GetWebsite();
        }

        this.Submitted = false;

      });
    }
  };


  ngOnInit() {
    this.GetJosaUrl();
    this.GetWebsite();
  }


  GetJosaUrl() {
    this.LookupService.GetLookupsList('JosaUrl', '').subscribe((data: any) => {
      this.JosaUrlList = data.LookupItems;
    });
  };



}

